// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__RNm1O","burgerIsOpen":"Burger_burgerIsOpen__dMDMk","line":"Burger_line__Cpzuu","menu":"Burger_menu__PYnlU","menuNone":"Burger_menuNone__0b43w"};